import React from 'react'
import PropTypes from "prop-types"
import "./photo_gallery.scss"

// 大量の画像を読み込まないようにサムネイルの表示枚数を制限する
const MAX_PHOTO = 4

export default class PhotoGallery extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      index: 0
    }
  }

  get imageWidth() {
    if (this._imageWidth) {
      return this._imageWidth
    }
    const pageWidth = window.innerWidth

    if (pageWidth >= 768) {
      this._imageWidth = 324
    } else if (pageWidth) {
      this._imageWidth = pageWidth - 58
    }
    return this._imageWidth
  }

  get devicePixelRatio() {
    if (this._devicePixelRatio) {
      return this._devicePixelRatio
    }
    if ("devicePixelRatio" in window) {
      this._devicePixelRatio = window.devicePixelRatio
    }
    return this._devicePixelRatio
  }

  onClickPhotoItem(e, index) {
    e.preventDefault()
    e.stopPropagation()
    this.setState({ index })
  }

  getListingPathById() {
    const { id, checkin, checkout, rooms, adults } = this.props
    return routeUrlHelper.listingPath(id, {
      checkin,
      checkout,
      rooms,
      adults
    })
  }

  transformPhotoUrl(photoUrl) {
    const w = this.imageWidth
    const h = Math.ceil((w * 2) / 3)
    const dpr = this.devicePixelRatio || 1
    const queryString = `?auto=format&auto=compress&fit=min${
      this.imageWidth ? `&w=${w}&h=${h}&dpr=${dpr}` : ``
    }`
    return `${photoUrl}${queryString}`
  }

  getPagerItemStyle(photoUrl) {
    return {
      backgroundImage: `url(${this.transformPhotoUrl(photoUrl)})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    }
  }

  getPhotoUrls() {
    const { photos, photos_imgix } = this.props // eslint-disable-line camelcase
    return (photos_imgix || photos).slice(0, MAX_PHOTO) // eslint-disable-line camelcase
  }

  get numberOfPhotos() {
    return this.props.totalPhotos
  }

  renderPhotoList() {
    const urls = this.getPhotoUrls()

    return urls.map((url, index) => {
      const selected = this.state.index

      if (index === selected) {
        // 選択中のlistにはlayer無し
        return (
          <li
            key={`${url}_${index}`}
            style={this.getPagerItemStyle(url)}
          >
            <meta itemProp="photo" content={url} />
          </li>
        )
      }

      if (index === MAX_PHOTO - 1) {
        // +n のマス
        return (
          <li
            key={`${url}_${index}`}
            style={this.getPagerItemStyle(url)}
          >
            <div styleName="layer layer-black">
              <a
                styleName="other-images"
                href={this.getListingPathById()}
                target="_blank"
              >
                <span className="notranslate">{`+${this.numberOfPhotos - (MAX_PHOTO - 1)}`}</span>
                <meta itemProp="photo" content={url} />
              </a>
            </div>
          </li>
        )
      }

      return (
        <li
          key={`${url}_${index}`}
          style={this.getPagerItemStyle(url)}
          onMouseEnter={(e) => this.onClickPhotoItem(e, index)}
        >
          <div styleName="layer layer-white">
            <meta itemProp="photo" content={url} />
          </div>
        </li>
      )
    })
  }

  render() {
    const { photos, photos_imgix: imgix, isSP } = this.props // eslint-disable-line camelcase
    const selected = (imgix || photos)[this.state.index]
    const firstPhoto = (imgix || photos)[0]
    const secondPhoto = (imgix || photos)[1]

    return (
      <div ref={this.ref} styleName="listing-gallery">
        {isSP
          ? <React.Fragment>
            <p style={this.getPagerItemStyle(firstPhoto)}>
              <meta itemProp="photo" content={firstPhoto} />
            </p>
            <p style={this.getPagerItemStyle(secondPhoto)}>
              <meta itemProp="photo" content={secondPhoto} />
            </p>
          </React.Fragment>
          : <React.Fragment>
            <a
              styleName="listing-photo-selected"
              style={this.getPagerItemStyle(selected)}
              href={this.getListingPathById()}
              target="_blank"
            >
              <meta
                itemProp="photo"
                content={selected}
              />
            </a>
            <ul styleName="listing-photo-list">
              {this.renderPhotoList()}
            </ul>
          </React.Fragment>
        }
      </div>
    )
  }
}

PhotoGallery.propTypes = {
  id: PropTypes.number.isRequired,
  checkin: PropTypes.string,
  checkout: PropTypes.string,
  adults: PropTypes.string,
  rooms: PropTypes.array,
  photos: PropTypes.array.isRequired,
  photos_imgix: PropTypes.array.isRequired,
  totalPhotos: PropTypes.number.isRequired,
  isSP: PropTypes.bool.isRequired
}

PhotoGallery.defaultProps = {
  adults: undefined,
  checkin: undefined,
  checkout: undefined
}
